import { ActionTree } from 'vuex'
import { UIState } from './types'
import { RootState } from '../types'
import { ThingsHelpers, MapsHelpers } from '@/helpers/mainExports'
declare const google: any
export const actions: ActionTree<UIState, RootState> = {
  toggleLayoutMovileLiveTracking({ commit }, value) {
    commit('toggleLayoutMovileLiveTracking', value)
  },
  closeDrawer({ commit }) {
    commit('toggleLayoutMovileLiveTracking', false)
    commit('closeDrawer')
  },
  initMapUIState({ commit }) {
    commit('initMapUIState')
  },
  setAmountOfThing({ commit }, amountOfThing) {
    commit('setAmountOfThing', amountOfThing)
  },
  setMainGridLoading({ commit }, value) {
    commit('setMainGridLoading', value)
  },
  toggleDrawer({ commit }) {
    commit('toggleDrawer')
  },
  toggleEntitiesDataTable({ commit, getters }) {
    if (
      getters.drawerComponent == '' ||
      getters.drawerComponent !== 'Entities'
    ) {
      commit('setDrawerComponent', 'Entities')
    } else {
      commit('setDrawerComponent', '')
    }
  },
  toggleFollow({ commit }) {
    commit('toggleFollow')
  },
  toggleNotificationsDataTable({ commit, getters }) {
    if (
      getters.drawerComponent == '' ||
      getters.drawerComponent !== 'Notifications'
    ) {
      commit('setDrawerComponent', 'Notifications')
    } else {
      commit('setDrawerComponent', '')
    }
  },
  toggleGeofencesDataTable({ commit, getters }) {
    if (
      getters.drawerComponent == '' ||
      getters.drawerComponent !== 'Geofences'
    ) {
      commit('setDrawerComponent', 'Geofences')
    } else {
      commit('setDrawerComponent', '')
    }
  },
  togglePointsOfInterestDataTable({ commit, getters }) {
    if (
      getters.drawerComponent == '' ||
      getters.drawerComponent !== 'PointsOfInterest'
    ) {
      commit('setDrawerComponent', 'PointsOfInterest')
    } else {
      commit('setDrawerComponent', '')
    }
  },
  toggleGeofenceMapLayer({ commit }, payload) {
    commit('setGeofenceMap', { showGeofencesMap: payload }, { root: true })
  },
  toggleMarkerCluster({ commit, rootState }, payload): any {
    if (
      !rootState.filterMustBeApplied &&
      rootState.totalAmountOfThings <= 999
    ) {
      const user_id = String(localStorage.getItem('user_id'))
      localStorage.setItem(
        `showMarkerCluster_${user_id}`,
        JSON.stringify(payload)
      )
    }
    commit('toggleCluster')
  },
  toggleVisibleNumerator({ commit, rootState, rootGetters }, showCluster) {
    const map: any = rootState.map
    const things = rootGetters['mapState/currentThings']

    const markers: any = []
    Object.keys(things).map(key => {
      // Se revisa que la entidad no esté dada de baja ni sea morosa en el pago del servicio de live tracking
      if (
        things[key].services['mrn:service:live_tracking']?.status !==
          'suspended' &&
        things[key].servicePlan?.status !== 'inactive'
      ) {
        const marker = things[key].marker
        markers.push(marker)
      }
    })

    if (showCluster) {
      commit(
        'setMarkerCluster',
        MapsHelpers.createMarkerCluster({ map, markers }),
        {
          root: true
        }
      )

      commit('toggleClusterCreated', true)
    } else if (rootState.markerCluster) {
      rootState.markerCluster.setMap(null)

      rootState.markerCluster.markers.forEach(marker => {
        marker.setMap(map)
      })
      commit('toggleClusterCreated', false)
    }
  },
  toggleEntityType({ commit, rootState }, payload): any {
    if (
      !rootState.filterMustBeApplied &&
      rootState.totalAmountOfThings <= 999
    ) {
      const user_id = String(localStorage.getItem('user_id'))
      localStorage.setItem(`showEntityType_${user_id}`, JSON.stringify(payload))
    }
    commit('toggleEntityType')
  },
  toggleAllMarkers({ commit, rootGetters }, showEntityType): any {
    const things = rootGetters['mapState/currentThings']

    //por cada thing se chequea si
    Object.keys(things).map(key => {
      const followedThings = rootGetters['mapState/getThingsToFollow']
      let follow = false
      for (let i = 0; i < followedThings.length; i++) {
        const element = followedThings[i]
        if (element.id === key) {
          follow = true
        }
      }

      const icon = ThingsHelpers.getThingIcon(
        {
          status: things[key].status,
          heading: things[key].heading,
          type: things[key].type,
          subType: things[key].subType,
          follow
        },
        showEntityType
      )

      const obj = {
        id: things[key].id,
        icon,
        showEntityType
      }
      commit('mapState/toggleMarkerType', obj, { root: true })
    })
  },
  toggleAllEntitysNames({ commit, rootGetters }, payload): any {
    const things = rootGetters['mapState/currentThings']

    Object.keys(things).map(thing => {
      const id = thing

      if (payload) {
        commit('mapState/setLabel', { id }, { root: true })
      } else {
        commit('mapState/removeLabel', { id }, { root: true })
      }
    })
  },
  toggleEntityName({ commit, rootState }, payload): any {
    if (
      !rootState.filterMustBeApplied &&
      rootState.totalAmountOfThings <= 999
    ) {
      const user_id = String(localStorage.getItem('user_id'))
      localStorage.setItem(`showEntityName_${user_id}`, JSON.stringify(payload))
    }
    commit('toggleEntityName')
  },
  toggleThingInfo({ commit }): any {
    commit('toggleThingInfo')
  },
  openSnackBar({ commit }, { msg, snackBarButtonClose }) {
    commit('openSnackBar', { msg, snackBarButtonClose })
  },
  closeSnackBar({ commit }) {
    commit('closeSnackBar')
  },
  openThingInfo({ commit }, thing): any {
    commit('openThingInfo', thing)
  },
  closeThingInfo({ commit }): any {
    commit('closeThingInfo')
  },
  closeLabelSelected({ commit }): any {
    commit('closeLabelSelected')
  },
  openTrailView({ commit }) {
    commit('openTrailView')
  },
  closeTrailView({ commit }) {
    commit('closeTrailView')
  },
  openTemperatureByTimeView({ commit }) {
    commit('openTemperatureByTimeView')
  },
  closeTemperatureByTimeView({ commit }) {
    commit('openTemperatureByTimeView')
  },
  setFollowTimerIsActive({ commit }, value) {
    commit('setFollowTimerIsActive', value)
  }
}
